import React, { useCallback, useEffect, useState } from 'react';

import Collapsible from '../../../../library/collapsible/collapsible';
import FitMessage from '../../../../components/fit-message/fit-message.one-dt';
import FitmentBanner from '../../../../library/fitment/components/fitment-banner/fitment-banner';

import { useFitment } from '../../../../shared/hooks/hooks';

import { trackAction } from '../../../../shared/utils/analytics/analytics';
import { formatTireSizeParts } from '../../../../shared/utils/format/format';

import { EXCLUDED, FIT } from '../../../../shared/constants/fit';

import './collapsible-fitment-page-banner.scss';

interface TireSize {
  aspectRatio?: string;
  crossDimension?: string;
  diameter?: string;
  height?: string;
  width?: string;
}

interface CollapsibleFitmentPageBannerProps {
  className?: string;
  doesFitEnum?: string;
  isLoading?: boolean;
  isPackage?: boolean;
  productType?: string;
  tireSizes?: {
    front?: TireSize | null;
    rear?: TireSize | null;
  };
}

function CollapsibleFitmentPageBanner(
  props: CollapsibleFitmentPageBannerProps
) {
  const {
    className = '',
    doesFitEnum,
    isLoading,
    isPackage,
    productType,
    tireSizes
  } = props;

  const [isOpen, setIsOpen] = useState(false);
  const { partialFitment, selectedFitment } = useFitment();

  const partialFitmentWithSizes = partialFitment
    ? {
        ...partialFitment,
        frontTireSize: formatTireSizeParts(tireSizes?.front || {}),
        frontWheelDiameter: tireSizes?.front?.diameter,
        isStaggered: Boolean(tireSizes?.rear),
        rearTireSize: formatTireSizeParts(tireSizes?.rear || {}),
        rearWheelDiameter: tireSizes?.rear?.diameter
      }
    : undefined;

  const defaultEditFitment = useCallback(() => {
    window.location.hash = '#/fitment/vehicle/edit/confirm';
  }, []);

  useEffect(() => {
    if ((!selectedFitment && !partialFitment) || isLoading) {
      setIsOpen(false);
    }
  }, [isLoading, partialFitment, selectedFitment]);

  return !isLoading ? (
    <div className={className} styleName="container">
      {selectedFitment || partialFitment ? (
        <Collapsible
          label={
            <>
              {doesFitEnum !== EXCLUDED && (
                <FitMessage
                  data-testid="FitMessage"
                  doesFit={selectedFitment && doesFitEnum === FIT}
                  fitment={selectedFitment || partialFitment}
                  isLoading={isLoading}
                  isPackage={isPackage}
                  productType={productType}
                  showFitmentDetails={!isOpen}
                />
              )}
            </>
          }
          onToggle={() => setIsOpen(!isOpen)}
          toggleType="CHEVRON"
        >
          {
            <FitmentBanner
              fitment={selectedFitment || partialFitmentWithSizes}
              hideDelete
              isPartialFitment={!selectedFitment && partialFitment}
              onEditFitment={() => {
                defaultEditFitment();
                trackAction('vehicle_page_edit');
              }}
              showChangeVehicleLink
              showEditLink
              styleName="fitment-banner"
            />
          }
        </Collapsible>
      ) : (
        <FitMessage
          data-testid="FitMessage"
          doesFit={false}
          fitment={selectedFitment || partialFitment}
          isPackage={isPackage}
          productType={productType}
        />
      )}
    </div>
  ) : null;
}

export default CollapsibleFitmentPageBanner;
